import LiveLocationCard from './LiveLocationCard';
import SendNotificationCard from './SendNotificationCard';
import ImportantContactsCard from './ImportantContactsCard';

const OnTripServicesSection = ({
  voucher,
  guests = [],
  handlePingUser,
  setNotificationType,
  onSaveContacts
}) => {
  return (
    <div className="vc-zone">
      <div className="vc-zone-label">
        <span className="vc-tag">On-Trip Services</span>
        <span className="vc-sub">manage &amp; reach your client while they travel</span>
        <span className="vc-rule"></span>
      </div>

      <div className="vc-grid vc-g-3">
        {/* Live location */}
        <LiveLocationCard
          voucher={voucher}
          guests={guests}
          handlePingUser={handlePingUser}
        />

        {/* Send notifications */}
        <SendNotificationCard
          handlePingUser={handlePingUser}
          setNotificationType={setNotificationType}
        />

        {/* Contacts */}
        <ImportantContactsCard
          voucher={voucher}
          onSaveContacts={onSaveContacts}
        />
      </div>
    </div>
  );
};

export default OnTripServicesSection;
